import React from 'react';
import '../style/Footer.css';
import {
  FaYoutube, FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-columns">
        <div className="footer-section">
          <h4>Connect With Us</h4>
          <input type="email" placeholder="Enter Email ID" />
          <div className="social-icons">
            <a href="#"><FaYoutube /></a>
            <a href="https://www.facebook.com/greateastern.org"><FaFacebookF /></a>
            <a href="https://www.instagram.com/greateasterntrading/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D#"><FaInstagram /></a>
            <a href="#"><FaLinkedinIn /></a>
            <a href="#"><FaTwitter /></a>
          </div>
        </div>
        <div className="footer-section">
          <h4>Useful Links</h4>
          <ul>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="#">FAQs</a></li>
            <li><a href="#">Returns</a></li>
            <li><a href="/storelocator">Store Locator</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Products</h4>
          <ul>
            <li><a href="/category/Televisions">Televisions</a></li>
            <li><a href="/category/Airconditioner">Air Conditioner</a></li>
            <li><a href="/category/Mobiles">Mobiles</a></li>
            <li><a href="/category/Laptops">Laptops</a></li>
            <li><a href="/category/Washing machines">Washing Machine</a></li>
          </ul>
        </div>
      </div>
      <p className="footer-bottom">© {new Date().getFullYear()} Great Eastern Trading Co. All right reserved</p>
      <p className="footer-bottom">Developed by Disha Studioz</p>
    </footer>
  );
};

export default Footer;
